var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThigh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Thigh") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Thigh",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.832018,3.98936957 C15.3567246,9.1292171 15.0621884,13.3351473 14.7241728,15.8134801 C14.2171493,19.5309793 13.7139565,22.4211082 13.4318405,23.7740604 C13.1497246,25.1270126 12.5920379,26.2175669 12.3375476,27.4492003 C12.0830573,28.6808337 12.6743858,33.4786947 12.5920379,35.1073106 C12.5371393,36.1930545 5.62554223,35.0018485 5.5358503,33.537974 C5.4013124,31.3421623 5.67247186,29.0363125 5.90132181,27.9994893 C6.13017175,26.9626661 6.41489496,25.6365088 6.41489496,22.9567353 C6.41489496,21.1702197 6.29133552,18.5544814 6.04421664,15.1095205 C5.67617963,12.08326 5.50672418,9.53354314 5.5358503,7.4603701 C5.56497641,5.38719705 5.81071518,2.50713029 6.27306658,-1.17983019 C6.32545374,-1.51371197 6.97383075,-4.90343935 8.66460786,-5.0810697 C12.4305305,-5.47671153 20.9607522,-6.3879815 24.981769,-5.0810697 C26.8706884,-4.46713272 26.4221199,-1.52917578 26.4769334,-1.17983019 C26.9392848,2.50713029 27.1850236,5.38719705 27.2141497,7.4603701 C27.2432758,9.53354314 27.0738204,12.08326 26.7057834,15.1095205 C26.4586645,18.5544814 26.335105,21.1702197 26.335105,22.9567353 C26.335105,25.6365088 26.6198283,26.9626661 26.8486782,27.9994893 C27.0775281,29.0363125 27.3486876,31.3421623 27.2141497,33.537974 C27.1244578,35.0018485 20.2128607,36.1930545 20.1579621,35.1073106 C20.0756142,33.4786947 20.6669427,28.6808337 20.4124524,27.4492003 C20.1579621,26.2175669 19.6002754,25.1270126 19.3181595,23.7740604 C19.0360435,22.4211082 18.5328507,19.5309793 18.0258272,15.8134801 C17.6878116,13.3351473 17.6689789,9.1292171 17.1936855,3.98936957 C17.1620448,3.73051275 17.0327164,4.22278348 16.5122034,4.22278348 C15.9916904,4.22278348 15.8636587,3.73051275 15.832018,3.98936957 Z",
    id: "background",
    fill: "#8596A1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "16 5.41472387 5.5 4.71395209 5.16189436 7.05696227 16 6.62787922"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "16 6.62787922 16 8.85906496 5.16189436 8.4807064 5.16189436 7.05696227"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "16 8.85906496 15.7145618 11.0946314 5.16189436 9.9768482 5.16189436 8.4807064"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "5.16189436 9.9768482 5.35444538 12.4057698 15.3782258 12.7724591 15.7145618 11.0946314"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "5.35444538 12.4057698 15.3782258 12.7724591 15.2198077 14.3285481 5.5 14.3285481"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "5.5 14.3285481 5.81743987 16.614839 14.9540725 16.2945446 15.2198077 14.3285481"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "14.9540725 16.2945446 14.6484268 18.4175627 5.95217288 18.7278574 5.81743987 16.614839"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "foreground",
    stroke: "#8596A1",
    strokeWidth: 0.5,
    fill: "#F6F6F6",
    points: "5.95217288 18.7278574 14.6484268 18.4175627 14.3965497 20.3493975 6.11056093 20.9083366"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThigh);
export default __webpack_public_path__ + "static/media/Thigh.942dbfbb302d1a035356aec24bc96aed.svg";
export { ForwardRef as ReactComponent };